/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Grid from "@mui/material/Grid";

import { useMainBannerStore } from "@/stores/useMainBannerStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { ROUTES, useMediaQueries } from "../../../../shared";
import useGeneralHeights from "../../../../shared/hooks/useGeneralHeights";
import FilterSeparator from "../../../FilterSeparator/FilterSeparator";
import Filters from "../../../Filters/Filters";
import FilteredValues from "../../../Filters/components/FilteredValues";
import Search from "../../../Search/Search";
import { useTableStyles } from "../../styles/styles";

import TableView from "./TableView/TableView";

interface ItableToolbarProps {
  toMd: boolean;
  route: ROUTES;
  hasTableView?: boolean;
  hasSearch?: boolean;
}

const TableToolbar = ({
  toMd,
  route,
  hasTableView,
  hasSearch = true
}: ItableToolbarProps) => {
  const { fromSm } = useMediaQueries();
  const {
    params: { hideFilters },
    initialLoading
  } = useTableStoreByRoute(route);

  const mainBannerHeight = useMainBannerStore(state => state.height);

  const { TABLE_TOOLBAR_PADDINGS } = useGeneralHeights(mainBannerHeight);
  const { tableToolbar, tableViewGridCSS } = useTableStyles();
  const showSeparator = fromSm && hasSearch && !hideFilters;

  const getWidth = (width1: number, width2: number) =>
    hasTableView ? width1 : width2;

  return (
    <>
      <Grid
        container
        size={12}
        sx={{
          justifyContent: "flex-end",
          padding: TABLE_TOOLBAR_PADDINGS(toMd, hasTableView)
        }}
        data-testid="table-toolbar"
      >
        <Grid
          size={{ xs: 12, md: getWidth(7, 12), lg: getWidth(6, 12) }}
          css={css(tableToolbar)}
        >
          {hasSearch && <Search route={route} stretchSearch={hideFilters} />}
          {showSeparator && (
            <FilterSeparator
              isInitialLoading={initialLoading}
              width={1}
              height={36}
            />
          )}
          {!hideFilters && <Filters route={route} />}
        </Grid>
        <Grid
          size={{ xs: 12, md: getWidth(5, 0), lg: getWidth(6, 0) }}
          css={css(tableViewGridCSS)}
        >
          {hasTableView && <TableView route={route} />}
        </Grid>
      </Grid>
      <FilteredValues />
    </>
  );
};

export default TableToolbar;
